import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';

/**
 * Получение информации об адресе
 */
export const addressInfo = (providerId: number, request: RequestDto): IRequest => ({
    uri: `/v1/${providerId}/sale-agent/address-company`,
    method: 'POST',
    body: JSON.stringify(request),
    withProvider: true,
});
